import { z } from 'zod';

export const russianPhoneSchema = z
    .string()
    .min(1, 'Введите номер')
    .transform(str => str.replace(/\D/g, ''))
    .refine(digits => digits.length === 11 && digits.startsWith('7'), {
        message: 'Номер должен быть в формате +7XXXXXXXXXX',
    })
    .transform(digits => `+${digits}`);
